/** Límites prudentes exportación ZIP MongoDB (navegador + caché IndexedDB). */

export const EXPORT_LIMITS = {
  /** Días de periodo: aviso / bloqueo */
  DAYS_WARN: 186,
  DAYS_BLOCK: 400,
  /** CFDI (solo XML) */
  COUNT_XML_WARN: 400,
  COUNT_XML_BLOCK: 2000,
  /** CFDI con PDF generado en servidor */
  COUNT_PDF_WARN: 120,
  COUNT_PDF_BLOCK: 550,
  /** Factor extra si emitidos+recibidos */
  TODOS_COUNT_FACTOR: 1,
  /** Tamaño ZIP descargado (bytes) */
  ZIP_BYTES_WARN: 80 * 1024 * 1024,
  ZIP_BYTES_NO_CACHE: 100 * 1024 * 1024,
  ZIP_BYTES_BLOCK: 250 * 1024 * 1024,
};

export function daysInPeriod(fechaInicio, fechaFin) {
  if (!fechaInicio || !fechaFin) return 0;
  const a = new Date(`${fechaInicio}T12:00:00`);
  const b = new Date(`${fechaFin}T12:00:00`);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return 0;
  return Math.max(0, Math.round((b - a) / 86400000) + 1);
}

/**
 * @returns {{ level: 'ok'|'warn'|'block', title: string, message: string }}
 */
export function assessExportBeforeGenerate({
  count,
  includePdf,
  dirScope,
  fechaInicio,
  fechaFin,
}) {
  const days = daysInPeriod(fechaInicio, fechaFin);
  const n = Number(count) || 0;
  const limits = EXPORT_LIMITS;
  const countBlock = includePdf ? limits.COUNT_PDF_BLOCK : limits.COUNT_XML_BLOCK;
  const countWarn = includePdf ? limits.COUNT_PDF_WARN : limits.COUNT_XML_WARN;

  if (days > limits.DAYS_BLOCK) {
    return {
      level: "block",
      title: "Periodo demasiado amplio",
      message: `El rango abarca ${days} días. Divida la exportación por mes o trimestre (máx. recomendado ~${limits.DAYS_WARN} días) para evitar bloqueos del navegador.`,
    };
  }

  if (n > countBlock) {
    return {
      level: "block",
      title: "Demasiados CFDI",
      message: `Hay unos ${n} XML en este alcance${includePdf ? " con PDF" : ""}. Use un periodo más corto o exporte solo XML (sin PDF) por partes.`,
    };
  }

  if (days > limits.DAYS_WARN || n > countWarn) {
    const parts = [];
    if (days > limits.DAYS_WARN) {
      parts.push(`periodo de ${days} días`);
    }
    if (n > countWarn) {
      parts.push(`${n} CFDI${dirScope === "todos" ? " (emitidos + recibidos)" : ""}`);
    }
    return {
      level: "warn",
      title: "Exportación pesada",
      message: `Volumen alto (${parts.join(", ")}). Se recomienda acotar a un mes o trimestre. Si continúa, la descarga puede tardar y no se guardará en caché si el ZIP supera ~100 MB.`,
    };
  }

  return { level: "ok", title: "", message: "" };
}

/**
 * @returns {{ level: 'ok'|'warn'|'block', message: string, skipCache: boolean }}
 */
export function assessZipBlobAfterDownload(blob, includePdf) {
  const size = blob?.size || 0;
  const limits = EXPORT_LIMITS;
  if (size >= limits.ZIP_BYTES_BLOCK) {
    return {
      level: "block",
      skipCache: true,
      message: `El ZIP pesa ${formatMb(size)} MB. Divida el periodo (por mes) y vuelva a exportar por partes.`,
    };
  }
  if (size >= limits.ZIP_BYTES_NO_CACHE) {
    return {
      level: "warn",
      skipCache: true,
      message: `ZIP de ${formatMb(size)} MB: descargado, pero no se guardó en caché local. Use periodos más cortos para re-descargar sin regenerar.`,
    };
  }
  if (size >= limits.ZIP_BYTES_WARN) {
    return {
      level: "warn",
      skipCache: false,
      message: `ZIP de ${formatMb(size)} MB${includePdf ? " (PDF incluidos)" : ""}. Para el siguiente intento, pruebe un mes o solo XML.`,
    };
  }
  return { level: "ok", skipCache: false, message: "" };
}

function formatMb(bytes) {
  return (bytes / (1024 * 1024)).toFixed(1);
}
